import {connect} from "react-redux";
import {getAlLDocuments, messageReset} from "../store/documents";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import DownloadIcon from '@mui/icons-material/Download';
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteDocument from "../blocks/deleteDocument";
import {toast} from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {Tab} from "@mui/material";
import {FormControl, InputAdornment, InputLabel, OutlinedInput, Pagination} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {TabContext, TabList} from "@mui/lab";
import TabPanel from "@mui/lab/TabPanel";

const PAGE_SIZE = 20

const CATEGORIES = [
    {key: 'all',       labelKey: 'all'},
    {key: 'kadastr',   labelKey: 'cat_kadastr'},
    {key: 'ustav',     labelKey: 'cat_ustav'},
    {key: 'guvohnoma', labelKey: 'cat_guvohnoma'},
    {key: 'xatlar',    labelKey: 'cat_xatlar'},
    {key: 'other',     labelKey: 'cat_other'},
]

function Documents(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const regionId = params.id || false

    const [open, setOpen] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [activeCategory, setActiveCategory] = useState('all')
    const [searchCompany, setSearchCompany] = useState('')
    const [page, setPage] = useState(1)
    const [adminRegionId, setAdminRegionId] = useState('')
    const [searchTimer, setSearchTimer] = useState(null)

    function fetchData(pg, cat, sc, rid) {
        const category = cat !== undefined ? cat : activeCategory
        const search   = sc  !== undefined ? sc  : searchCompany
        const _rid     = rid !== undefined ? rid : (regionId || adminRegionId || '')
        props.getAlLDocuments(
            pg || page,
            PAGE_SIZE,
            category === 'all' ? '' : category,
            search,
            _rid,
            '',
            ''
        )
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid)
        setPage(1)
        props.getAlLDocuments(1, PAGE_SIZE, activeCategory === 'all' ? '' : activeCategory, searchCompany, rid, '', '')
    }

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token !== 'undefined') {
            props.getAllVerifyResponse({"token": JSON.parse(token)})
        }
        fetchData(1, 'all', '')
    }, [])

    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            setOpenItem(false); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => { setPage(1); fetchData(1, activeCategory, searchCompany) }, 400)
        setSearchTimer(timer)
    }, [searchCompany])

    function handleCategoryChange(e, newVal) {
        setActiveCategory(newVal); setPage(1)
        fetchData(1, newVal, searchCompany)
    }

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function getCategoryLabel(catKey) {
        const cat = CATEGORIES.find(c => c.key === catKey)
        return cat ? t(cat.labelKey) : catKey
    }

    const documents = props.documents || []

    return <div>
        <div className={'page worker-page documents'}>
            {open ? <DeleteDocument setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                        {t('back')}
                    </Button>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{t('required_documents')}</h2>
                        {!is_main && (
                            <Button variant="contained" endIcon={<AddIcon/>}
                                    onClick={() => navigate('/add-document/')}>
                                {t('add_document')}
                            </Button>
                        )}
                    </div>

                    {is_main && !regionId && (
                        <div style={{marginBottom: '16px'}}>
                            <FormControl variant="outlined" style={{minWidth: 300}}>
                                <InputLabel htmlFor="search-doc">{t('search_company')}</InputLabel>
                                <OutlinedInput
                                    id="search-doc" value={searchCompany}
                                    onChange={(e) => setSearchCompany(e.target.value)}
                                    endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                    label={t('search_company')}/>
                            </FormControl>
                        </div>
                    )}

                    {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}

                    <div className="documents-tabs">
                        <TabContext value={activeCategory}>
                            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                                <TabList onChange={handleCategoryChange} variant="scrollable" scrollButtons="auto">
                                    {CATEGORIES.map(cat => (
                                        <Tab key={cat.key} value={cat.key} label={t(cat.labelKey)}/>
                                    ))}
                                </TabList>
                            </Box>
                            {CATEGORIES.map(cat => (
                                <TabPanel key={cat.key} value={cat.key}>
                                    {documents.length ? (
                                        <table className="table table-hover table-responsive">
                                            <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                {is_main && <th scope="col">{t('title_company')}</th>}
                                                <th scope="col">{t('document_title')}</th>
                                                {cat.key === 'all' && <th scope="col">{t('doc_category')}</th>}
                                                <th scope="col">{t('download')}</th>
                                                <th scope="col"/>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {documents.map((item, index) => (
                                                <tr key={item.id}>
                                                    <th scope="row">{(page - 1) * PAGE_SIZE + index + 1}</th>
                                                    {is_main && <td>{item.user?.user_name || 'ADMIN'}</td>}
                                                    <td>{item.title}</td>
                                                    {cat.key === 'all' && <td>{getCategoryLabel(item.category)}</td>}
                                                    <td>
                                                        <a href={item.file} target={'_blank'} rel="noreferrer">
                                                            <DownloadIcon title={t('download')}/>
                                                        </a>
                                                    </td>
                                                    {is_main || !item.user?.is_main ? (
                                                        <td>
                                                            {is_main && !regionId && (
                                                                <Button variant="contained" color="info"
                                                                        endIcon={<EditIcon/>}
                                                                        onClick={() => navigate('/edit-document/' + item.id)}/>
                                                            )}
                                                            {!is_main && (
                                                                <Button variant="contained" color="error"
                                                                        endIcon={<DeleteIcon/>}
                                                                        onClick={() => {setOpenItem(item); setOpen(true)}}/>
                                                            )}
                                                        </td>
                                                    ) : (
                                                        <td style={{minHeight: "42px"}}/>
                                                    )}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className={'no-infos'}>{t('no_info')}</div>
                                    )}
                                    {props.total_pages > 1 && (
                                        <div style={{display: 'flex', justifyContent: 'center', padding: '20px 0'}}>
                                            <Pagination count={props.total_pages} page={page}
                                                        onChange={handlePageChange} color="primary" shape="rounded"/>
                                        </div>
                                    )}
                                </TabPanel>
                            ))}
                        </TabContext>
                    </div>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.documents, {getAlLDocuments, getAllVerifyResponse, messageReset})(Documents)
